<otui-modal
  [visible]="visible"
  [heading]="config.appName"
  [size]="'lg'"
  [variant]="'glass'"
  [ariaLabel]="config.appName + ' about dialog'"
  [closeOnBackdrop]="true"
  [closeOnEscape]="true"
  data-testid="hai-about-modal"
  (close)="handleClose()"
>
  <div class="about-shell">
    <header class="about-hero">
      <div class="hai-mark" aria-hidden="true">
        <span>HAI</span>
      </div>
      <div class="about-intro">
        <p class="eyebrow">{{ currentExpansion }}</p>
        <h3>{{ config.appName }}</h3>
        <p class="tagline">{{ config.appTagline }}</p>
        <p class="savannah-line">
          Made with Love in Savannah - {{ currentExpansion }}
        </p>
      </div>
    </header>

    <otui-tabs
      [tabs]="tabs"
      [wrap]="true"
      [activeTab]="activeTab"
      (tabChange)="setActiveTab($event)"
    ></otui-tabs>

    <section class="about-panel">
      @if (activeTab === 'app') {
      <div class="copy-stack">
        <p class="panel-label">About This App</p>
        <p>{{ config.appDescription }}</p>
        <p data-testid="hai-account-context">
          {{
            config.accountNotice ||
              'HAI apps are related products. Opening another app may ask you to sign in.'
          }}
          Your selected profile, preferences, and unsaved work do not
          automatically carry over between apps.
        </p>
        @if (config.appUrl) {
        <a class="primary-link" [href]="config.appUrl"
          >Open {{ config.appName }}</a
        >
        }
      </div>
      } @if (activeTab === 'hai') {
      <div class="copy-stack">
        <p class="panel-label">About HAI</p>
        <p>
          HAI is a software development house focused on cloud platforms,
          personal cloud software, and the practical systems people need to own
          more of their digital lives.
        </p>
        <p>
          We build for teams, homes, and homelabs that want calm infrastructure,
          thoughtful interfaces, and tools that support digital homesteading
          instead of lock-in.
        </p>
      </div>
      } @if (activeTab === 'directory') {
      <div class="directory-grid">
        @for (app of appLinks$ | async; track app.appId) {
        <article class="directory-card" data-testid="hai-app-card">
          <header class="directory-head">
            <span class="directory-icon" aria-hidden="true">
              @if (app.logoSrc) {
              <img [src]="app.logoSrc" [alt]="" />
              } @else {
              <otui-icon
                name="extension"
                [size]="22"
                stroke="currentColor"
              ></otui-icon>
              }
            </span>
            <span class="directory-heading-copy">
              <span class="directory-name">{{ app.name }}</span>
              <span class="directory-category">{{ app.category }}</span>
            </span>
            <span
              class="directory-status"
              [class.is-live]="app.isPublic"
              [attr.data-state]="app.isPublic ? 'running' : 'repository'"
            >
              {{ app.isPublic ? 'App link' : 'Repository' }}
            </span>
          </header>

          <p class="directory-tagline">{{ app.tagline }}</p>

          <div class="directory-actions">
            @if (app.runUrl) {
            <a
              class="directory-link directory-link-primary"
              [href]="app.runUrl"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hai-app-run-link"
              [attr.aria-label]="'Open ' + app.name + ' (opens in a new tab)'"
            >
              <otui-icon
                name="external-link"
                [size]="16"
                stroke="currentColor"
              ></otui-icon>
              <span>Open app</span>
            </a>
            }
            <a
              class="directory-link directory-link-secondary"
              [href]="app.repositoryUrl"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hai-app-repo-link"
              [attr.aria-label]="
                'View the ' + app.name + ' repository (opens in a new tab)'
              "
            >
              <otui-icon
                name="code"
                [size]="16"
                stroke="currentColor"
              ></otui-icon>
              <span>View repository</span>
            </a>
          </div>
        </article>
        }
      </div>
      }
    </section>
  </div>
</otui-modal>
